/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportStatusResponse {
    getFixupPrototypeFunction() { return ReportStatusResponse.fixupPrototype; }

    static newInstance(model: Partial<ReportStatusResponse>): ReportStatusResponse {
        let obj = Object.assign(new ReportStatusResponse(), model);
        ReportStatusResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportStatusResponse>): ReportStatusResponse {
        if (!model) return null;
        return ReportStatusResponse.newInstance(<ReportStatusResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportStatusResponse) {
        if (!obj) return;

        models.ReportStatusResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportStatusResponse): boolean {
        Object.setPrototypeOf(obj, ReportStatusResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Status of the report
     */
    status: models.ReportStatus;

    /**
     * Error message when report generation failed.
     */
    failure_message: string;

}
